<template>
    <tr v-if="dataRow" v-bind:class="rowOdd ? 'odd' : 'even'">
        <td v-bind:data-th="$t('site.date')">
            {{startDate}}
        </td>
        <td v-bind:data-th="$t('site.size')">
            {{size}}
        </td>
        <td v-text="localGetProfileName" v-bind:data-th="$t('site.profile')">
        </td>
        <td class="text-center">
            <div v-if="last_test_state === -1 && is_testable === 1" class="backup-action">
                <button v-on:click="localTestBackup()" class="btn btn--primary">
                    <img class="btn__icon" src="images/icon/siteinformation/icon_test.svg">{{$t('site.testnow')}}
                </button>
            </div>
            <font-awesome-icon v-else-if="last_test_state == 0" :icon="['fal','spinner']" pulse></font-awesome-icon>
            <font-awesome-icon v-else-if="last_test_state == 1" :icon="['fal','spinner']" pulse></font-awesome-icon>
            <span v-if="testProgress !== null">{{testProgress}} %</span>
            <font-awesome-icon v-else-if="last_test_state == 2" class="text--success" :icon="['fal','check-circle']"></font-awesome-icon>
            <span v-else-if="last_test_state == 3"  :title="last_test_reason" v-b-tooltip.hover>
                <font-awesome-icon class="text--danger" :icon="['fal','exclamation-triangle']"></font-awesome-icon>
            </span>
        </td>
    </tr>

</template>

<script>

import { mapActions, mapState, mapGetters } from 'vuex'

import mixins from '../../mixins'

export default {

  name: 'SiteDetailBackupItem',

  mixins: [mixins],

  props: [
    'id',
    'remotesite_backupstart',
    'remotesite_totalsize',
    'remotesite_profile_id',
    'remotesite_state',
    'rowType',
    'rowOdd',
    'backup_tools',
    'backup_tools_installed',
    'last_test_state',
    'is_testable',
    'last_test_reason'
  ],

  computed: {
    ...mapState('user', [
      'userTimezone'
    ]),

    ...mapState('progress', [
      'backuptests'
    ]),

    ...mapGetters('progress', [
      'backupTestProgress'
    ]),

    testProgress () {
      return this.backupTestProgress(this.id)
    },

    dataRow () {
      return this.rowType === 'data'
    },

    showMessage () {
      return false
    },

    startDate () {
      return this.transformTime(this.remotesite_backupstart, this.userTimezone)
    },

    size () {
      return String(Math.round(this.remotesite_totalsize / (1024 * 1024))) + 'MB'
    },

    localGetProfileName () {
      if (this.backup_tools_installed !== true) {
        return ''
      }

      return this.getProfileName(this.backup_tools, this.remotesite_profile_id)
    }
  },

  methods: {

    ...mapActions('backup', [
      'startBackupTest'
    ]),

    localTestBackup () {
      this.startBackupTest(this.id)
      this.last_test_state = 0
    }
  }
}
</script>
